// generated
export const GATEWAY_VERSION = "0.16.2-beta.0";
